(() => {
  'use strict';

  const init = () => {
    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');

    const closeMenu = () => {
      if (!toggle || !menu || !menu.classList.contains('is-open')) return;
      toggle.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
      const label = toggle.querySelector('.visually-hidden');
      if (label) label.textContent = 'Open menu';
    };

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu();
        toggle?.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 900) closeMenu();
    });

    const mobileBuy = document.querySelector('[data-mobile-buy]');
    const shop = document.querySelector('#shop');
    if (mobileBuy && shop && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const hasReachedShop = entry.isIntersecting || entry.boundingClientRect.top < 0;
        mobileBuy.classList.toggle('is-hidden', hasReachedShop);
        mobileBuy.setAttribute('aria-hidden', String(hasReachedShop));
      }, { threshold: 0.08 });

      observer.observe(shop);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
